module.exports = __webpack_public_path__ + "img/try.2d9aab10.jpg";